import App from './App';
import React,{Component} from "react";
import ReactDOM from "react-dom";

window.AppComponent = App;
window.React = React;
window.ReactDOM = ReactDOM;

/*ReactDOM.render(
    <App ref={(myAppComponent)=>{ 
        window.AppComponent = myAppComponent
        console.log(myAppComponent);
    
    }}/>,
    document.getElementById('welcomespuser') 
);     
 */